// checked_in,checked_out,no_show,early_checkout

export const BookingMark = [
    { value: 'checked_in', label: 'Checked In' },
    { value: 'checked_out', label: 'Checked Out' },
    { value: 'no_show', label: 'No Show' },
    { value: 'early_checkout', label: 'Early Checkout' },
]

export type BookingMarkType = typeof BookingMark[number]['value']